import React, { Fragment, useState } from "react";
import { Collapse } from "@mui/material";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { htmlParse } from "@unisearch/helpers/utils";
import styles from "./faq.module.scss";

export const FAQSection = ({ isCollapsed = true, title, faqData }) => {
  const [selected, setSelected] = useState(null);
  const toggle = (i) => {
    if (selected == i) {
      return setSelected(null);
    }
    setSelected(i);
  };

  return (
    <section className={styles.section_faq}>
      <div className="container">
        {title && <h2 className={`${styles.title} center`}>{title}</h2>}

        <Fragment>
          {faqData &&
            faqData.map((item, index) => (
              <div className={styles.wrapper} key={index}>
                {isCollapsed && (
                  <div
                    className={`${styles.title_wrapper} ${
                      selected == index ? `${styles.active}` : ""
                    }`}
                    onClick={() => toggle(index)}
                  >
                    <div className={`${styles.title}`}>{item?.faqQuestion}</div>
                    {selected == index ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                )}

                {!isCollapsed && (
                  <div
                    className={`${styles.title_wrapper} ${styles.active}`}
                    style={{ cursor: "default" }}
                  >
                    <div className={`${styles.title}`}>{item?.faqQuestion}</div>
                  </div>
                )}

                {isCollapsed && (
                  <Collapse in={selected == index} timeout="auto" unmountOnExit>
                    <div
                      className={`${styles.desc_wrapper} from_texteditor_wrapper`}
                    >
                      <div className={styles.desc}>
                        {item.faqAnswer && item.faqAnswer != ""
                          ? htmlParse(item.faqAnswer)
                          : ""}
                      </div>
                    </div>
                  </Collapse>
                )}

                {!isCollapsed && (
                  <div
                    className={`${styles.desc_wrapper} from_texteditor_wrapper`}
                  >
                    <div className={styles.desc}>
                      {item.faqAnswer && item.faqAnswer != ""
                        ? htmlParse(item.faqAnswer)
                        : ""}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </Fragment>
      </div>
    </section>
  );
};

export default FAQSection;
